import { controls, grouped } from "../controls";
const track_the_girl_childs = {
    label: "Track The Girl Childs",
    pageLabel: "Track The Girl Childs", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: true } },
    insertButton: { label: "New", location: "top" },

    pageType: "history",
    filter: [
        // ...controls.displayText({ tab: "filter", label: "District" }),
        // ...controls.oc({ tab: "filter", c: "District", placeHolder: "District Code", name: "TrackTheGirlChild-district-district_code", fastpath: "districts", hidden: true, defaultValue: "parb", isReadOnly: true }),
        // ...controls.showData({ tab: "filter", displaytype: "capital", data: "TrackTheGirlChild-district-district_display", width: "col-sm-2" }),
        // ...controls.displayText({ tab: "filter", label: "Taluka" }),
        // ...controls.oc({ tab: "filter", c: "Taluka", placeHolder: "Taluka Code", name: "TrackTheGirlChild-taluka-taluka_code", fastpath: "talukas", hidden: true, defaultValue: "parbhani", isReadOnly: true }),
        // ...controls.showData({ tab: "filter", displaytype: "capital", data: "TrackTheGirlChild-taluka-taluka_display", width: "col-sm-2" }),
        // ...controls.displayText({ tab: "filter", label: "Village" }),
        // ...controls.oc({ tab: "filter", c: "Village", placeHolder: "Village Code", name: "TrackTheGirlChild-village-village_code", fastpath: "villages", hidden: true, isReadOnly: true }),
        // ...controls.showData({ tab: "filter", displaytype: "capital", data: "TrackTheGirlChild-village-village_display", width: "col-sm-2" }),
        ...controls.displayText({ tab: "filter", label: "Full Name[मुलीचे पूर्ण नाव]" }),
        ...controls.text({ tab: "filter", placeHolder: "", name: "name", width: "col-sm-2", maxlength: 200 }),

        ...controls.displayText({ tab: "filter", label: "Mothers Name[आईचे पूर्ण नाव]" }),
        ...controls.text({ tab: "filter", placeHolder: "", name: "mothers_name", width: "col-sm-2", maxlength: 200 }),

        ...controls.displayText({ tab: "filter", label: "Fathers Name[वडिलांचे पूर्ण नाव]" }),
        ...controls.text({ tab: "filter", placeHolder: "", name: "fathers_name", width: "col-sm-2", maxlength: 200 }),

        ...controls.magicDateLabel({ tab: "general", label: "Date Of Birth[जन्मतारीख]", target: "date_of_birth", }),
        ...controls.magicDate({ tab: "general", name: "date_of_birth", dateType: "ontype" }),


    ]
    , form: [
        // ...controls.displayText({ tab: "general", label: "Select Village/Ward", star: true }),
        // ...controls.oc({
        //     tab: "general", c: "AssignSevikaToVillage", placeHolder: "Select Assigned Village/Ward", name: "assign_sevika_to_village_code", fastpath: "assign_sevikas_to_villages", isRequired: true,
        // displayData: {
        //     village_code: "village_code", village_display: "village_display", taluka_code: "taluka_code", taluka_display: "taluka_display",
        //     area_type_code: "area_type_code", area_type_display: "area_type_display",
        //     village_uid: "village_uid", taluka_uid: "taluka_uid", area_type_uid: "area_type_uid",
        //     assign_sevika_to_village_uid: "assign_sevika_to_village_uid",
        //     assign_sevika_to_village_display: "assign_sevika_to_village_display"

        // },
        //     width: "col-sm-4"
        // }),


        // // ...controls.showData({ tab: "general", displaytype: "capital", data: "assign_sevika_to_village_display", width: "col-sm-2" }),



        ...controls.displayText({
            tab: "general", label: "Select Village/ Ward\n[निवडा गाव/ प्रभाग]", width: "col-sm-4", star: true
        }),
        ...controls.autoComplete({
            tab: "general", name: "assign_sevika_to_village_code", controlType: "AssignSevikaToVillage", width: "col-sm-4",
            displayData: {
                village_code: "village_code", village_display: "village_display", taluka_code: "taluka_code", taluka_display: "taluka_display",
                area_type_code: "area_type_code", area_type_display: "area_type_display",
                village_uid: "village_uid", taluka_uid: "taluka_uid",
                area_type_uid: "area_type_uid"


            },
        }),
        // ...controls.displayText({ tab: "filter", label: "" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),



        ...controls.displayText({
            tab: "general", label: "District[जिल्हा]", star: true,
            width: "col-sm-4"
        }),
        ...controls.oc({ tab: "general", c: "District", placeHolder: "District Code", name: "district_code", isRequired: true, fastpath: "districts", hidden: true, defaultValue: "parb", isReadOnly: true }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "district_display", width: "col-sm-4" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),



        ...controls.displayText({ tab: "general", label: "Taluka[तालुका]", star: true, width: "col-sm-4" }),
        ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired: true, fastpath: "talukas", hidden: true, isReadOnly: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display", width: "col-sm-4" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),


        // ...controls.displayText({ tab: "general", label: "Village", star: true, hidden: true }),
        ...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", isRequired: true, hidden: true, fastpath: "villages", isReadOnly: false }),
        // ...controls.showData({ tab: "general", displaytype: "capital", data: "village_display", width: "col-sm-4", hidden: true }),
        // ...controls.displayText({ tab: "general", label: "", width: "col-sm-6" }),


        ...controls.displayText({
            tab: "general", label: "AreaType[क्षेत्र प्रकार]", star: true,
            width: "col-sm-4"
        }),
        ...controls.oc({ tab: "general", c: "AreaType", placeHolder: "Area Type", name: "area_type_code", isRequired: true, fastpath: "area_types", hidden: true, isReadOnly: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "area_type_display", width: "col-sm-4" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),


        ...controls.displayText({
            tab: "general", label: "Full Name[मुलीचे पूर्ण नाव]", star: true,
            width: "col-sm-4"
        }),
        ...controls.text({ tab: "general", placeHolder: "", name: "name", isRequired: true, width: "col-sm-4", maxlength: 200 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),

        ...controls.displayText({
            tab: "general", label: "Mothers Name[आईचे पूर्ण नाव]", star: true, width: "col-sm-4"
        }),
        ...controls.text({ tab: "general", placeHolder: "", name: "mothers_name", isRequired: true, width: "col-sm-4", maxlength: 200, isRequired: true }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),

        ...controls.displayText({
            tab: "general", label: "Fathers Name[वडिलांचे पूर्ण नाव]", star: true,
            width: "col-sm-4"
        }),
        ...controls.text({ tab: "general", placeHolder: "", name: "fathers_name", isRequired: true, width: "col-sm-4", maxlength: 200, isRequired: true }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),


        ...controls.magicDateLabel({
            tab: "general", label: "Date Of Birth[जन्मतारीख]", target: "date_of_birth", star: true,
            width: "col-sm-4"
        }),
        ...controls.magicDate({ tab: "general", name: "date_of_birth", dateType: "ontype", isRequired: true, width: "col-sm-4", }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),

        ...controls.displayText({
            tab: "general", label: "Aadhaar[आधार क्रमांक]",
            width: "col-sm-4"
        }),
        ...controls.aadharNumber({ tab: "general", placeHolder: "", name: "aadhaar", maxlength: 12, width: "col-sm-4", }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),



        ...controls.displayText({
            tab: "general", label: "Contact Number[संपर्क क्रमांक]", width: "col-sm-4"
        }),
        ...controls.mobileNumber({ tab: "general", placeHolder: "", name: "contact_number", maxlength: 10, width: "col-sm-4", }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),

        ...controls.displayText({
            tab: "filter", label: "Religion[धर्म]", star: true,
            width: "col-sm-4"
        }),
        ...controls.autoComplete({ tab: "filter", name: "religion_code", controlType: "Religion", width: "col-sm-4", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),
        // ...controls.displayText({ tab: "general", label: "Religion", star: false }),
        // ...controls.oc({ tab: "general", c: "Religion", placeHolder: "Religion Code", name: "religion_code", fastpath: "religions", hidden: false }),
        // ...controls.showData({ tab: "general", displaytype: "capital", data: "religion_display", width: "col-sm-4" }),


        // ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),
        ...controls.displayText({
            tab: "general", label: "Caste[जात]", star: false,
            width: "col-sm-4"
        }),
        ...controls.text({ tab: "general", placeHolder: "", name: "caste", width: "col-sm-4", maxlength: 100, isRequired: true }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),

        ...controls.displayText({
            tab: "filter", label: "Child Status[मुलीची सद्यस्थिती]", star: true,
            width: "col-sm-4"
        }),
        ...controls.autoComplete({ tab: "filter", name: "child_status_code", width: "col-sm-4", controlType: "ChildStatus", isRequired: true }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),


        // ...controls.displayText({ tab: "general", label: "Child Status", star: true }),
        // ...controls.oc({ tab: "general", c: "ChildStatus", placeHolder: "Child Status Code", name: "child_status_code", isRequired: true, fastpath: "child_statues", hidden: false }),
        // ...controls.showData({ tab: "general", displaytype: "capital", data: "child_status_display", width: "col-sm-4" }),
        // ...controls.displayText({ tab: "general", label: "", width: "col-sm-4" }),
        ...controls.displayText({ tab: "general", label: "Remark[शेरा]", width: "col-sm-4", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "remark", width: "col-sm-4", maxlength: 200 }),
    ]
    , history: {
        perPage: 10,
        reportHeader: "Track The Girl Childs",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "District", accessor: "TrackTheGirlChild-district-district_display", },
            { Header: "Taluka", accessor: "TrackTheGirlChild-taluka-taluka_display", },
            { Header: "Village", accessor: "TrackTheGirlChild-village-village_display", },
            { Header: "Name", accessor: "name", },
            { Header: "Mothers Name", accessor: "mothers_name", },
            { Header: "Fathers Name", accessor: "fathers_name", },
            { Header: "Child Status", accessor: "TrackTheGirlChild-child_status-child_status_display", },
        ]
    }
};
export default track_the_girl_childs;
